import { render } from "./subTopicRelease.vue?vue&type=template&id=11c715cc&scoped=true"
import script from "./subTopicRelease.vue?vue&type=script&lang=js"
export * from "./subTopicRelease.vue?vue&type=script&lang=js"

import "./subTopicRelease.vue?vue&type=style&index=0&id=11c715cc&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11c715cc"]])

export default __exports__